/**
 * FairwayBid – die Wetterabfrage
 *
 * Open-Meteo, weil es ohne Schlüssel, ohne Anmeldung und ohne Vertrag
 * auskommt. Wir schicken zwei Zahlen (Breite und Länge einer Leitregion)
 * und bekommen die Tagesprognose – keine Adresse, kein Nutzer, kein Konto
 * verlässt dabei den Browser.
 *
 * Gefragt wird einmal je Stunde. Eine Tagesprognose ändert sich nicht
 * schneller, und jede Abfrage mehr wäre eine, die der Nutzer wartet.
 */

const CACHE_PREFIX = 'fwb.wetter.';

const speicher = () => {
  try {
    return typeof window !== 'undefined' ? window.sessionStorage : null;
  } catch (e) {
    return null;
  }
};

/** Ein Schlüssel je Ort und Stunde – so verfällt der Stand von selbst. */
export const cacheKey = (lat, lon, jetzt = new Date()) =>
  `${CACHE_PREFIX}${lat.toFixed(2)},${lon.toFixed(2)}.${jetzt.toISOString().slice(0, 13)}`;

export const ausCache = key => {
  const s = speicher();
  if (!s) return null;
  try {
    const roh = s.getItem(key);
    return roh ? JSON.parse(roh) : null;
  } catch (e) {
    return null;
  }
};

export const inCache = (key, daten) => {
  const s = speicher();
  if (!s) return;
  try {
    s.setItem(key, JSON.stringify(daten));
  } catch (e) {
    // Voller Speicher: Dann wird eben noch einmal gefragt.
  }
};

export const urlFuer = (lat, lon) =>
  'https://api.open-meteo.com/v1/forecast' +
  `?latitude=${lat}&longitude=${lon}` +
  '&daily=weather_code,temperature_2m_max,temperature_2m_min,precipitation_probability_max' +
  '&timezone=Europe%2FBerlin&forecast_days=1';

/**
 * Holt die Tagesprognose für einen Punkt.
 *
 * Ein Fehler ist hier kein Fehler: Ohne Wetter fehlt eine Kachelzeile,
 * sonst nichts. Deshalb faengt die Funktion alles ab und liefert null.
 */
export const holeWetter = async (lat, lon) => {
  if (typeof lat !== 'number' || typeof lon !== 'number') return null;

  const key = cacheKey(lat, lon);
  const gespeichert = ausCache(key);
  if (gespeichert) return gespeichert;

  try {
    const antwort = await fetch(urlFuer(lat, lon));
    if (!antwort.ok) return null;
    const daten = await antwort.json();
    const daily = daten?.daily || null;
    if (daily) inCache(key, daily);
    return daily;
  } catch (e) {
    return null;
  }
};
